import React from 'react'
import styles from "./LoadingSpinner.module.css";


export default function LoadingSpinner() {
  return (
    <div className={styles.spinnerBackground}>
      <div className={styles.spinner}>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  )
}
